import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(private analytics: AngularFireAnalytics) { }

 /**
  * @override
  * Tracking out of stock products added to cart
  */
  oosProductsInCart(event) {
    this.analytics.logEvent('oos_in_cart',event);
  }
}
